import * as React from "react"
import type { SVGProps } from "react"
const SvgSeo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.5 14.36a3.5 3.5 0 0 0 1.9-.55l1.53 1.57a.6.6 0 0 0 .5.21 1 1 0 0 0 .55-.2.8.8 0 0 0 .23-.55.7.7 0 0 0-.21-.53l-1.55-1.55a3.4 3.4 0 0 0 .55-1.9q0-1.48-1.04-2.49a3.4 3.4 0 0 0-2.46-1.01q-1.42 0-2.46 1.01T8 10.86t1.04 2.49a3.4 3.4 0 0 0 2.46 1m0-1.5q-.83 0-1.41-.59a2 2 0 0 1-.59-1.41q0-.82.59-1.41a2 2 0 0 1 1.41-.6q.8 0 1.4.6.6.59.6 1.4 0 .84-.59 1.42a2 2 0 0 1-1.41.59m-9.5 9a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.72a1 1 0 0 1 .71-.28h20q.42 0 .71.28.3.3.29.72 0 .42-.29.71a1 1 0 0 1-.71.29zm2-3q-.82 0-1.41-.59a2 2 0 0 1-.59-1.4v-11q0-.82.59-1.42A2 2 0 0 1 4 3.86h16q.83 0 1.41.59.6.59.59 1.4v11q0 .84-.59 1.42a2 2 0 0 1-1.41.59zm0-2h16v-11H4z" />
  </svg>
)
export default SvgSeo
